import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-golf-flag",
  "use": "icon-si-glyph-golf-flag-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-golf-flag\" id=\"icon-si-glyph-golf-flag\"><title>1009</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><ellipse cx=\"5.433\" cy=\"14.98\" rx=\"5.433\" ry=\"0.98\" class=\"si-glyph-fill\" /><rect x=\"5\" y=\"0\" width=\"0.956\" height=\"12.959\" class=\"si-glyph-fill\" /><path d=\"M7.031,0.103 C7.031,0.103 8.675,-0.317 11.481,1.564 C14.287,3.446 13.73,5.076 15.584,5.21 C16.582,5.144 15.164,6.378 13.73,5.814 C10.949,4.721 10.13,3.177 7.031,4.604 L7.031,0.103 L7.031,0.103 Z\" class=\"si-glyph-fill\" /><circle cx=\"13.945\" cy=\"13.945\" r=\"1.945\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-golf-flag.svg
// module id = MIXO
// module chunks = 62